import {
  equalTo,
  onValue,
  orderByChild,
  query,
  ref,
  type Database,
  type Unsubscribe,
} from 'firebase/database';

import { DEVICES_ROOT, INDEXED_FIELDS, parseDeviceRecord, type DeviceRecord } from '@remote/shared';

export interface DeviceEntry {
  deviceId: string;
  record: DeviceRecord;
}

/**
 * Escucha la lista de dispositivos del usuario.
 *
 * La query filtra por `ownerUid` porque es la única forma que las reglas permiten
 * de leer `/devices`: no se puede pedir la colección entera, solo consultarla
 * filtrando por tu propio uid.
 */
export function watchDevices(
  db: Database,
  ownerUid: string,
  onChange: (devices: DeviceEntry[]) => void,
): Unsubscribe {
  const devicesQuery = query(
    ref(db, DEVICES_ROOT),
    orderByChild(INDEXED_FIELDS.deviceOwner),
    equalTo(ownerUid),
  );

  return onValue(devicesQuery, (snapshot) => {
    const devices: DeviceEntry[] = [];

    snapshot.forEach((child) => {
      const deviceId = child.key;
      const record = parseDeviceRecord(child.val());
      if (deviceId !== null && record !== null) {
        devices.push({ deviceId, record });
      }
      // `forEach` de RTDB corta la iteración si devuelves true. No es lo que queremos.
      return false;
    });

    // Los encendidos primero, y dentro de cada grupo por nombre.
    devices.sort((a, b) => {
      if (a.record.online !== b.record.online) return a.record.online ? -1 : 1;
      return a.record.name.localeCompare(b.record.name, 'es');
    });

    onChange(devices);
  });
}
